(() => {
  function setup(root) {
    if (root.dataset.ready || root.dataset.layoutSample === 'true' || !root.querySelector('[data-cart-state]')) return;
    root.dataset.ready = 'true';
    const core = CftBagCore, storageKey = 'cft-bag-choices';
    let cart = core.activeCart(JSON.parse(root.querySelector('[data-cart-state]').textContent)), choices = new Map();
    let revision = 0, busy = false, quoteReady = false, controller;
    try { choices = new Map(JSON.parse(sessionStorage.getItem(storageKey) || '[]')); } catch (_) { /* Storage is optional. */ }
    const find = name => root.querySelector(`[data-cart-${name}]`);
    const selected = () => new Set(cart.items.filter(item => choices.get(core.identity(item)) !== false).map(core.identity));
    const status = text => { const el = find('status'); if (el) el.textContent = text; };
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: cart.currency, currencyDisplay: 'narrowSymbol'
    }).format(value) + ' ' + cart.currency;
    const save = () => { try { sessionStorage.setItem(storageKey, JSON.stringify([...choices])); } catch (_) { /* Optional. */ } };
    const quantityRule = row => {
      const input = row.querySelector('[data-cart-quantity]');
      return { min: Number(input.min) || 1, step: Number(input.step) || 1, max: Number(input.max) || Infinity };
    };
    function controls() {
      root.setAttribute('aria-busy', String(busy));
      root.querySelectorAll('input, button').forEach(el => { el.disabled = busy; });
      const button = find('checkout');
      if (button) button.disabled = busy || !selected().size || !quoteReady;
      root.querySelectorAll('[data-cart-row]').forEach(row => {
        const item = cart.items.find(i => i.key === row.dataset.cartKey);
        if (item) {
          const rule = quantityRule(row);
          row.querySelector('[data-cart-minus]').disabled = busy || item.quantity <= rule.min;
          row.querySelector('[data-cart-plus]').disabled = busy || item.quantity + rule.step > rule.max;
        }
      });
    }
    function totals(amounts) {
      if (!find('total')) return;
      find('subtotal').textContent = money(amounts.subtotal);
      find('discounts').textContent = amounts.discounts ? '−' + money(amounts.discounts) : 'None applied';
      find('total').textContent = money(amounts.total);
    }
    function draw() {
      const chosen = selected();
      if (find('bag-total')) find('bag-total').textContent = money(cart.total_price / 100);
      if (find('bag-discounts')) find('bag-discounts').textContent = cart.total_discount ? '−' + money(cart.total_discount / 100) : 'None applied';
      const quantity = cart.items.filter(i => chosen.has(core.identity(i))).reduce((n, i) => n + i.quantity, 0);
      root.querySelectorAll('[data-cart-row]').forEach(row => {
        const item = cart.items.find(i => i.key === row.dataset.cartKey);
        if (item) row.querySelector('[data-cart-select]').checked = chosen.has(core.identity(item));
      });
      if (!find('select-all')) return;
      find('select-all').checked = !!chosen.size && chosen.size === cart.items.length;
      find('select-all').indeterminate = !!chosen.size && chosen.size < cart.items.length;
      find('count').textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;
      find('selection-caption').textContent = `${quantity} ${quantity === 1 ? 'item' : 'items'} selected`;
    }
    async function json(url, options = {}) {
      const response = await fetch(url, {credentials: 'same-origin', ...options});
      const body = await response.json();
      if (!response.ok) throw new Error(body.description || 'Unable to update your bag. Please try again.');
      return body;
    }
    async function quote(chosen, signal) {
      const input = core.input(cart, chosen, root.dataset.country);
      const body = await json(root.dataset.storefrontUrl, {method: 'POST', signal,
        headers: {'Content-Type': 'application/json'}, body: JSON.stringify({query: core.query,
          variables: {input, first: input.lines.length}})});
      const result = body.data?.cartCreate;
      if (body.errors?.length || !result?.cart || result.userErrors?.length || result.warnings?.length)
        throw new Error('Unable to prepare this selection. Please review your bag and try again.');
      const output = result.cart, actual = output.lines.nodes;
      if (actual.length !== input.lines.length || input.lines.some(line =>
        !actual.some(item => item.merchandise.id === line.merchandiseId && item.quantity === line.quantity)))
        throw new Error('An item changed availability. Please review your bag before checkout.');
      const checkout = new URL(output.checkoutUrl);
      if (checkout.protocol !== 'https:' || ![location.hostname, 'yavka0-wc.myshopify.com', 'checkout.shopify.com'].includes(checkout.hostname))
        throw new Error('Unable to open checkout. Please try again.');
      return {url: checkout.href, ...core.amounts(output, cart.currency)};
    }
    async function calculate() {
      const current = ++revision;
      controller?.abort(); controller = new AbortController();
      quoteReady = false; draw(); save();
      const chosen = selected();
      if (!chosen.size) { totals({subtotal: 0, discounts: 0, total: 0}); status('Choose an item to check out.'); controls(); return; }
      if (chosen.size === cart.items.length) {
        totals({subtotal: cart.original_total_price / 100, discounts: cart.total_discount / 100, total: cart.total_price / 100});
        quoteReady = true; status(''); controls(); return;
      }
      ['subtotal', 'discounts', 'total'].forEach(name => { find(name).textContent = 'Calculating…'; });
      status('Calculating your selected items…'); controls();
      try {
        const amounts = await quote(chosen, controller.signal);
        if (current !== revision) return;
        totals(amounts); quoteReady = true; status('');
      } catch (error) { if (current === revision && error.name !== 'AbortError') {
        ['subtotal', 'discounts', 'total'].forEach(name => { find(name).textContent = '—'; }); status(error.message);
      } }
      if (current === revision) controls();
    }
    function replace(markup, nextCart) {
      const next = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-cft-bag]');
      if (!next) throw new Error('Please refresh your bag to see the latest changes.');
      root.replaceChildren(...next.childNodes); cart = core.activeCart(nextCart);
    }
    async function refresh(nextCart) {
      const url = new URL(location.href);
      url.searchParams.set('sections', root.dataset.sectionId);
      const sections = await json(url.href);
      replace(sections[root.dataset.sectionId], nextCart);
    }
    async function change(row, quantity) {
      if (busy) return;
      const item = cart.items.find(i => i.key === row.dataset.cartKey);
      if (!item) return;
      const rule = quantityRule(row);
      if (!Number.isInteger(quantity) || quantity < 0 || (quantity !== 0 &&
        (quantity < rule.min || quantity > rule.max || (quantity - rule.min) % rule.step !== 0))) {
        status(`Choose a quantity from ${rule.min}${Number.isFinite(rule.max) ? ` to ${rule.max}` : ''}, in steps of ${rule.step}. Use Remove to delete the item.`);
        row.querySelector('[data-cart-quantity]').value = item.quantity;
        return;
      }
      if (quantity === item.quantity) return;
      busy = true; ++revision; controller?.abort(); controls(); status('Updating your bag…');
      try {
        const sectionsUrl = location.pathname + location.search;
        const next = await json(root.dataset.changeUrl + '.js', {method: 'POST',
          headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id: item.key, quantity,
            sections: [root.dataset.sectionId], sections_url: sectionsUrl})});
        const markup = next.sections?.[root.dataset.sectionId];
        if (markup) replace(markup, next); else await refresh(next);
        busy = false; await calculate();
      } catch (error) {
        // An interrupted response may still have changed Shopify's cart. Read it before another update.
        try { await refresh(await json(root.dataset.cartUrl + '.js')); } catch (_) { /* Report the original failure. */ }
        busy = false; draw(); quoteReady = false; controls(); status(error.message);
      }
    }
    async function checkout(event) {
      event.preventDefault();
      if (busy || !quoteReady || !selected().size) return;
      busy = true; controls(); status('Preparing checkout…');
      try {
        const fresh = core.activeCart(await json(root.dataset.cartUrl + '.js'));
        if (core.fingerprint(fresh) !== core.fingerprint(cart)) {
          await refresh(fresh); busy = false; await calculate(); status('Your bag changed. Review the items before checking out.'); return;
        }
        const chosen = selected();
        if (chosen.size === cart.items.length) { location.assign(root.dataset.checkoutUrl); return; }
        const previous = find('total').textContent;
        const prepared = await quote(chosen);
        totals(prepared);
        if (previous !== money(prepared.total)) { busy = false; controls(); status('Your selected total changed. Review it, then choose Checkout again.'); return; }
        // The independent checkout leaves every unselected original cart line untouched.
        location.assign(prepared.url);
      } catch (error) { busy = false; controls(); status(error.message); }
    }
    root.addEventListener('change', event => {
      if (busy) return;
      const target = event.target, row = target.closest('[data-cart-row]');
      if (target.matches('[data-cart-select-all]')) { cart.items.forEach(i => choices.set(core.identity(i), target.checked)); calculate(); }
      else if (target.matches('[data-cart-select]')) { const item = cart.items.find(i => i.key === row.dataset.cartKey); choices.set(core.identity(item), target.checked); calculate(); }
      else if (target.matches('[data-cart-quantity]')) change(row, target.value === '' ? NaN : Number(target.value));
    });
    root.addEventListener('click', event => {
      const target = event.target.closest('button'), row = target?.closest('[data-cart-row]');
      if (!row || busy) return;
      const quantity = Number(row.querySelector('[data-cart-quantity]').value);
      const rule = quantityRule(row);
      if (target.matches('[data-cart-remove]')) change(row, 0);
      else if (target.matches('[data-cart-plus]')) change(row, Math.min(rule.max, quantity + rule.step));
      else if (target.matches('[data-cart-minus]')) change(row, Math.max(rule.min, quantity - rule.step));
    });
    root.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.matches('[data-cart-quantity]')) {
        event.preventDefault(); change(event.target.closest('[data-cart-row]'), event.target.value === '' ? NaN : Number(event.target.value));
      }
    });
    root.addEventListener('submit', checkout);
    calculate();
  }
  const init = () => document.querySelectorAll('[data-cft-bag]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
